/**
 * Converts a backend key (camelCase, snake_case, or kebab-case) into a human-readable label.
 * Handles camelCase, snake_case, and kebab-case formats and capitalizes each word.
 * 
 * @param {string} key - Backend key to format (e.g., "payorPolicy", "policy_assistant", "corpus-manager")
 * @returns {string} Human-readable formatted title (e.g., "Payor Policy", "Policy Assistant", "Corpus Manager")
 * 
 * @example
 * ```tsx
 * const title = formatTitleFromKey('payorPolicy');
 * // Returns: 'Payor Policy'
 * 
 * const title2 = formatTitleFromKey('policy_assistant');
 * // Returns: 'Policy Assistant'
 * ```
 */
export const formatTitleFromKey = (key: string): string => {
  if (!key) return "";

  return key
    .replace(/([A-Z])/g, " $1")          // camelCase → "camel Case"
    .replace(/[-_]/g, " ")               // snake / kebab → spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()) // capitalize each word
    .trim();
};